import styled from 'styled-components';

import { flex } from '@/styles/minix';
import { colorGroup } from '@/styles/common';

export const StandardWrap = styled.div`
	.title {
		font-size: 16px;
		font-weight: 500;
		color: ${colorGroup.textImportant};
	}
	.body {
		padding: 20px;
		height: 389px;
		overflow: auto;
		.item {
			${flex('row', undefined, 'center')}
			margin-bottom: 20px;
			.key {
				font-size: 14px;
				font-weight: 400;
				color: ${colorGroup.textSlight};
				text-align: right;
				margin-right: 12px;
				span {
					color: ${colorGroup.tipRed};
				}
			}
		}
		.mobile {
			.input {
				height: 38px;
			}
		}
		.avatar {
			.icon {
				width: 45px;
				height: 45px;
				border-radius: 50%;
				overflow: hidden;
			}
		}
		input.input {
			height: 38px;
			padding: 0 8px;
			border-radius: 2px;
			border: 1px solid ${colorGroup.lineSlight};
		}
		.input {
		}
		input.input:hover,
		.team .input:hover,
		.major .input:hover {
			background-color: ${colorGroup.bgPage};
		}
		input.input:focus {
			border: 1px solid ${colorGroup.primaryHoverColor};
		}
		input {
			outline-style: none;
		}
	}
	.footer {
		height: 54px;
		box-sizing: border-box;
		border-top: solid ${colorGroup.lineInferior} 2px;
		${flex('row', 'space-between', 'center')}
		padding: 0 20px;
		.control {
			display: flex;
			div {
				width: 70px;
				height: 32px;
				${flex('row', 'center', 'center')}
				border-radius: 2px;
				font-size: 14px;
				font-weight: 400;
				cursor: pointer;
			}
			.confirm {
				background: ${colorGroup.primaryColor};
				color: ${colorGroup.whiteColor};
			}
			.cancel {
				color: ${colorGroup.textPrimary};
			}
			.cancel:hover {
				text-decoration: underline;
			}
		}
	}
`;
export const TipsWrap = styled.div`
	color: #a9adba;
	font-size: 12px;
	padding: 0 12px;
	.tips-item {
		padding-left: 36px;
		margin-top: 8px;
	}
`;
